module.exports = __webpack_public_path__ + "static/img/mole.1b56924d.png";